<template>
  <div class="category-banner-wrapper">
    <!-- Masaüstü: 3 slide -->
    <div class="banner-pc" v-if="!isMobileOrTablet">
      <div class="embla" ref="emblaPC">
        <div class="embla__container">
       <div
  v-for="(banner, index) in banners"
  :key="banner._id"
  class="embla__slide banner-card"
>
  <div class="banner-content">
    <span class="promo-label">{{ $t('sidebar.promotions') }}</span> 

    <h3 class="banner-title">{{ $t(banner.title) }}</h3>
    <p class="banner-subtitle">{{ $t(banner.subtitle) }}</p>

    <a
      class="banner-btn"
      :href="banner.link"
    >
      {{ $t('home.See All') }}
    </a>
  </div>

  <!-- Sağdaki büyük ikon -->
  <img :src="backendUrl + banner.imageUrl" class="banner-icon" />
</div>

        </div>
      </div>
      

      <div class="progress-dots">
       <div
  v-for="(banner, index) in banners"
  :key="index"
  class="dot"
  :class="{
    active: index === selectedIndex,
    passed: index < selectedIndex
  }"
>
  <div
    v-if="index === selectedIndex"
    class="fill"
    :key="progressKey"
  ></div>
        </div>
      </div>
    </div>

    <!-- Mobil: 1 slide -->
    <div class="banner-mobile" v-else>
      <div class="embla" ref="emblaMobile">
        <div class="embla__container">
        <div
  v-for="(banner, index) in banners"
  :key="banner._id"
  class="embla__slide banner-card"
>
  <div class="banner-content">
    <span class="promo-label">{{ $t('sidebar.promotions') }}</span>

     
    <h3 class="banner-title">{{ $t(banner.title) }}</h3>
    <p class="banner-subtitle">{{ $t(banner.subtitle) }}</p>

    <a class="banner-btn" :href="banner.link">
      {{ $t('home.See All') }}
    </a>
  </div>

  <img :src="backendUrl + banner.imageUrl" class="banner-icon" />
</div>

        </div>
      </div>

      <div class="progress-dots">
        <div
          v-for="(banner, index) in banners"
          :key="index"
          class="dot"
          :class="{
  active: index === selectedIndexMobile,
  passed: index < selectedIndexMobile
}"
        >
          <div
            v-if="index === selectedIndexMobile"
            class="fill"
            :key="progressKeyMobile"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import axios from 'axios'
import emblaCarousel from 'embla-carousel'

const banners = ref([])
const backendUrl = process.env.VUE_APP_BACKEND_URL || 'https://play.rivobit.com'

const isMobileOrTablet = ref(false)

const selectedIndex = ref(0)
const progressKey = ref(0)
const selectedIndexMobile = ref(0)
const progressKeyMobile = ref(0)

const emblaPC = ref(null)
const emblaMobile = ref(null)
let emblaInstancePC = null
let emblaInstanceMobile = null

const scrollNextPC = () => emblaInstancePC?.scrollNext()
const scrollPrevPC = () => emblaInstancePC?.scrollPrev()

let intervalPC = null
let intervalMobile = null

onMounted(async () => {
  isMobileOrTablet.value = window.innerWidth <= 1024

  try {
    // ▼ Home pozisyonuna göre veri alıyoruz
    const res = await axios.get(`/public/banners`)
    banners.value = (res.data || []).filter(b => b.position === 'HomeTop')
  } catch (err) {
    console.error('Banner fetch error:', err)
  }

  await nextTick()

  if (emblaPC.value) {
    emblaInstancePC = emblaCarousel(emblaPC.value, {
      loop: true,
      align: 'start',
      slidesToScroll: 1,
    })
    emblaInstancePC.on('select', () => {
      selectedIndex.value = emblaInstancePC.selectedScrollSnap()
      progressKey.value++
    })
  }

  if (emblaMobile.value) {
    emblaInstanceMobile = emblaCarousel(emblaMobile.value, {
      loop: true,
      align: 'center',
      slidesToScroll: 1,
    })
    emblaInstanceMobile.on('select', () => {
      selectedIndexMobile.value = emblaInstanceMobile.selectedScrollSnap()
      progressKeyMobile.value++
    })
  }

  intervalPC = setInterval(() => {
    if (!isMobileOrTablet.value && emblaInstancePC && banners.value.length > 1) {
      emblaInstancePC.scrollNext()
    }
  }, 5000)

  intervalMobile = setInterval(() => {
    if (isMobileOrTablet.value && emblaInstanceMobile && banners.value.length > 1) {
      emblaInstanceMobile.scrollNext()
    }
  }, 5000)
})

onUnmounted(() => {
  clearInterval(intervalPC)
  clearInterval(intervalMobile)
  emblaInstancePC?.destroy()
  emblaInstanceMobile?.destroy()
})
</script>

 


<style scoped>
.category-banner-wrapper {
  width: 100%;
  margin-bottom: 10px;
}

.banner-card {
  position: relative;
  background: var(--background3);
  border-radius: 14px;
  overflow: hidden;
  padding: 20px;
  height: 220px;
  display: flex;
  align-items: center;
 
}

/* Sol taraf yazılar */
.banner-content {
  position: relative;
  z-index: 3;
  width: 55%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.promo-label {
  background: var(--background2);
  color: #d0e7ff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
  width: fit-content;
}

.banner-title {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.banner-subtitle {
  margin: 0;
  margin-top: 4px;
  color: #c9d8e8;
  font-size: 15px;
}

/* See more button */
.banner-btn {
  margin-top: 12px;
   background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
  padding: 8px 16px;
  border-radius: 8px;
  color: white;
  width: fit-content;
  font-weight: 600;
  text-decoration: none;
  transition: 0.2s;
}

.banner-btn:hover {
  opacity: 0.8;
}

/* Sağ taraftaki büyük ikon */
.banner-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 100%;
  width: auto;
  opacity: 0.95;
  z-index: 1;
  pointer-events: none;
}

 

@media (max-width: 1024px) {
  .banner-card {
    height: 160px;
    padding: 14px;
    flex-direction: column;
    justify-content: center;
  }

  .banner-content {
    width: 100%;
    z-index: 3;
  }

  .banner-title {
    font-size: 16px;
  }

  .banner-subtitle {
    font-size: 13px;
  }

  .banner-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .banner-icon {
    height: 100%;
    right: 0;
    bottom: 0;
    opacity: 0.85;
  }

  .embla__slide {
    flex: 0 0 90%;
    height: 160px !important;
  }
}


.embla {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.embla__container {
  display: flex;
  user-select: none;
}
.embla__slide {
  position: relative;
  flex: 0 0 33.3333%;
  min-width: 0;
  margin-right: 12px;
  border-radius: 10px;
  overflow: hidden;
  height: 220px;

}
 
.embla__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  background: none;
  border: none;
  font-size: 20px;
  color: #8899a8;
  cursor: pointer;
  transition: color 0.2s;
}
.embla__arrow--prev {
  left: -32px;
}
.embla__arrow--next {
  right: -32px;
}
.embla__arrow:hover {
  color: #fff;
}
.progress-dots {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  gap: 6px;
}
.dot {
  width: 18px;
  height: 8px;
  background: var(--bar-outer);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.dot.active {
  width: 38px;
  height: 8px;
  background: var(--bar-outer);
}

.dot.passed {
  background: var(--bar-inner);
}
.fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--bar-inner);
  border-radius: 8px;
  animation: progressFill 5s linear forwards;
}
@keyframes progressFill {
  from { width: 0%; }
  to { width: 100%; }
}

/* Mobil özel: 1 slide ortalanmış, dotlar */
@media (max-width: 1024px) {
  .embla__slide {
    flex: 0 0 90%;
    margin-right: 8px;
    height: 140px;
  }
  
}
</style>
